var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('xolas-table',{attrs:{"title":_vm.title,"url":"/contractors","fields":_vm.fields,"table-ref":"contractors-table","layer-component":"siteContractor","layer-args":{ id: 'id' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }